import { useEffect, useState } from "react";
import cancelImage from "../assets/images/cancel.png";
import closeImage from "../assets/images/close.png";
import editImage from "../assets/images/edit.png";
import { useGetTodoQuery } from "../features/api/apiSlice"
import { useEditTodoMutation, useDeleteTodoMutation} from "../features/api/apiSlice";
export default function Todo({ todo }) {

    const [inputField,setInputField] = useState(false);
    const { text, id, completed, color } = todo;
    const [input, setInput] = useState(text);
    const { data: todoFetched} = useGetTodoQuery(todo.id,{skip:!inputField});
    const [editTodo, { isLoading, isError, isSuccess }] = useEditTodoMutation();
    const [deleteTodo]  = useDeleteTodoMutation();


    const handleStatusChange = (todoId) => {
        editTodo({id,data:{type:'completed',value:!todo.completed}});
    };

    const handleEditClick = (todoId) => {
        setInputField(true);
    };

    useEffect(()=>{
        if(todoFetched?.id){
            setInput(todoFetched.text)
        }
    },[todoFetched])

    const handleColorChange = (todoId, color) => {
        editTodo({id,data:{type:'color',value:color}});
    };

    const handleDelete = (todoId) => {
        deleteTodo(todoId)
    };

    const submitHandler = (e) => {
        e.preventDefault();
        editTodo({id,data:{type:'text',value:input}});
        setInput("");
        setInputField(false);
    };

    const handleInput = (e) => {
        setInput(e.target.value);
    };

    return (
<>
{isLoading ?
<p className="m-3 pl-2"> loading . . . . .</p>
:
<div className={`flex justify-start items-center p-2  ${!inputField && 'hover:bg-gray-100 hover:transition-all'}  space-x-4 border-b border-gray-400/20 last:border-0`}>
    <div
        className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
            completed &&
            "border-green-500 focus-within:border-green-500"
        }`}
    >
        <input
            type="checkbox"
            checked={completed}
            onChange={() => handleStatusChange(id)}
            className="opacity-0 absolute rounded-full cursor-pointer"
        />
        {completed && (
            <svg
                className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                viewBox="0 0 20 20"
            >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
        )}
    </div>

{inputField ?
        <form
            className="flex w-full items-center bg-gray-100 px-3 py-3 rounded-md"
            onSubmit={submitHandler}
        >
            <input
                type="text"
                className=" flex-initial w-90  w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
                value={input}
                onChange={handleInput}
            />
            <button
            type="button"
            className={`flex-initial w-10 appearance-none w-5 h-5 bg-[url('${closeImage}')] bg-no-repeat bg-contain`}
            onClick={()=>setInputField(false)}
        >  </button>
        </form> 
        :
        <>
        <div
            className={`select-none flex-1 ${completed && "line-through"}`}
        >
            {text}
        </div>      
        </>
}


    <>
                <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
                    color === "green" && "bg-green-500"
                }`}
                onClick={() => handleColorChange(id, "green")}
            ></div>

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
                    color === "yellow" && "bg-yellow-500"
                }`}
                onClick={() => handleColorChange(id, "yellow")}
            ></div>
        

            <div
                className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
                    color === "red" && "bg-red-500"
                }`}
                onClick={() => handleColorChange(id, "red")}
            ></div>

            {!inputField &&
                    <div
                    className={`appearance-none cursor-pointer w-5 h-5 bg-[url('${editImage}')] bg-no-repeat bg-contain bg-white-500  "
                    }`}
                    onClick={handleEditClick}
                ></div>

            }

            <img
                src={cancelImage}
                className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                alt="Cancel"
                onClick={() => handleDelete(id)}
            />
    </>

</div>
}




</>


    );
}
